/**
 * Module dependencies.
 */

import { NextPage } from 'next/types';
import Legal from 'src/components/legal';
import useTranslate from 'src/hooks/use-translate';

/**
 * `CookiesPolicy` page.
 */

const CookiesPolicy: NextPage = () => {
  const { translate } = useTranslate();

  return (
    <Legal
      subtitle={translate('cookies-policy:subtitle')}
      text={translate('cookies-policy:text')}
      title={translate('cookies-policy:title')}
    />
  );
};

/**
 * Export `CookiesPolicy` page.
 */

export default CookiesPolicy;
